export class ChangeBufferItem {
    constructor(public readonly warehouseCode: string,
        public readonly warehouseName: string,
        public readonly sku: string,
        public readonly name: string,
        public readonly buffer: number) {
        
    }

    newBuffer: number;

    reason: string;
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/chage-buffer-item.ts